import { render } from "./PillsButton.vue?vue&type=template&id=5bdd2a1c"
import script from "./PillsButton.vue?vue&type=script&lang=js"
export * from "./PillsButton.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "5bdd2a1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5bdd2a1c', script)) {
    api.reload('5bdd2a1c', script)
  }
  
  module.hot.accept("./PillsButton.vue?vue&type=template&id=5bdd2a1c", () => {
    api.rerender('5bdd2a1c', render)
  })

}

script.__file = "src/ui/buttons/PillsButton.vue"

export default script